/**
 * Number Formatting Utilities
 *
 * Pure functions for consistent number formatting across the application.
 * Handles floating-point rounding to avoid display artifacts like "76.44999999999999".
 */

/**
 * Format a number to specified decimal places, removing trailing .0 for integers.
 * Used for hours display to avoid floating-point artifacts.
 *
 * @param value - Number to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string without trailing .0 for whole numbers
 *
 * @example
 * formatDecimal(76.44999999999999) // => "76.5"
 * formatDecimal(8) // => "8"
 * formatDecimal(7.5) // => "7.5"
 */
export function formatDecimal(value: number, decimals: number = 1): string {
  const factor = Math.pow(10, decimals);
  const rounded = Math.round(value * factor) / factor;
  return Number.isInteger(rounded)
    ? rounded.toString()
    : rounded.toFixed(decimals);
}
